import {SocialListType} from '../../shared/modal/components/social-list/social-list-type.type';

export type ReactionListStatus = 'idle' | 'loading' | 'success' | 'error';

export interface ReactionListCacheKey {
  listType: SocialListType;
  subjectId: string;
  page: number;
}

export interface ReactionListPageState {
  ids: string[];
  status: ReactionListStatus;
  hasMore: boolean;
  loadedAt: number | null;
}

export interface ReactionListsState {
  pages: Record<string, ReactionListPageState>;
}

export function createReactionListPageKey({listType, subjectId, page}: ReactionListCacheKey): string {
  return `${listType}::${subjectId}::${page}`;
}

